import React from 'react'

const LoaderButton = () => {
    return <div className='loading-button' />
}

export default LoaderButton
